import React from "react";
import Card from "src/componets/Card";
import { ServerInterface } from "src/store/mine_craft/serversSlice";

const _Details = ({ server }: { server: ServerInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Connection</h4>
        <div className='v-server-connection'>
          {server?.ip}:{server?.port} {server?.version && <span>({server.version})</span>}
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Description</h4>
        {server?.description}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body</h4>
        <div dangerouslySetInnerHTML={{ __html: server?.description_html || '' }} />
      </Card>
    </>
  );
}

export default _Details;
